import { render, staticRenderFns } from "./accountSafe.vue?vue&type=template&id=596ff29e"
import script from "./accountSafe.vue?vue&type=script&lang=js"
export * from "./accountSafe.vue?vue&type=script&lang=js"
import style0 from "./accountSafe.vue?vue&type=style&index=0&id=596ff29e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports